// Get brand color schemes data
const brandColorSchemes = document.getElementById('brandColorSchemes').textContent;
const brandColorSchemesObj = JSON.parse(brandColorSchemes);
const defaultBrand = document.getElementById('brandColorSchemes')?.dataset?.defaultBrand;
// Function to get current brand parameter, or set it to the first brand in the brandColorSchemesObj if not set
function getCurrentBrandParam() {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString); 

  if(!params.get('brand')){
    // set to the first brand in the brandColorSchemesObj or the default brand if set
    params.set('brand', defaultBrand || Object.keys(brandColorSchemesObj)[0]);
    window.history.replaceState({}, "", "?" + params.toString());
  }
  return params.get('brand');
}
// Function to update anchor links with brand parameter
function updateAnchorLinks(brandParam) {
  if (!brandParam) return;
  
  const anchorLinks = document.querySelectorAll('a[href]');
  
  Array.from(anchorLinks).forEach((link) => {
    const href = link.getAttribute('href');
    
    if (href.startsWith('mailto:') || 
        href.startsWith('tel:') || 
        href.startsWith('#')) {
      return;
    }
    
    try {
      const url = new URL(href, window.location.origin);
      // Skip external links
      if (url.origin !== window.location.origin) return;
      
      // Check if this link is inside a branded menu (desktop mega menu or mobile nav)
      // Update brand parameter to the menu's own brand name
      const brandContainer = link.closest('[class*="brand-color-scheme__"]');
      if (brandContainer) {
        const brandClass = Array.from(brandContainer.classList)
          .find(className => className.startsWith('brand-color-scheme__'));
        if (brandClass) {
          url.searchParams.set('brand', brandClass.replace('brand-color-scheme__', ''));
        }
      } else {
        // If not in a branded menu, use the brand parameter passed to the function
        url.searchParams.set('brand', brandParam);
      }
      
      link.setAttribute('href', url.pathname + url.search);
    } catch (error) {
      console.warn('[brand-switcher] Failed to parse href:', href, error);
    }
  });
}

function handleBrandSections(brandParam) {
  if (!brandParam) return;
  
  const brandSections = document.querySelectorAll('.branded-section');
  Array.from(brandSections).forEach((section) => {
    if(section.classList.contains(`show-for-brand__${brandParam}`)) {
      section.classList.remove('hidden');
    } else {
      section.classList.add('hidden');
    }
  });
}
// Function to handle brand parameter changes and apply all associated functionality
function handleBrandChange(brandParam) {

  if (brandParam) {
    const brandSchemeId = brandColorSchemesObj[brandParam];
    if (brandSchemeId) {
      
      // Update color schemes
      const schemedElements = document.querySelectorAll('.color-scheme');
      Array.from(schemedElements).forEach((element) => {
        // Filter classes that start with 'color-scheme--'
        const elementColorSchemeClasses = Array.from(element.classList).filter((className) => {
          return /^color-scheme--/.test(className);
        });
        
        elementColorSchemeClasses.forEach((oldClass) => {
          element.classList.replace(oldClass, `color-scheme--${brandSchemeId}`);
        });
      });
      
      // Update hide/show branded sections
      handleBrandSections(brandParam);
      
      // Update all anchor links
      updateAnchorLinks(brandParam);
    }
  }
}

// Function to monitor URL changes
function setupBrandParameterMonitoring() {
  // Initial execution
  const initialBrandParam = getCurrentBrandParam();
  handleBrandChange(initialBrandParam);
  
  // Monitor for URL changes (including browser back/forward)
  window.addEventListener('popstate', () => {
    const newBrandParam = getCurrentBrandParam();
    handleBrandChange(newBrandParam);
  });
  
  // Monitor for programmatic URL changes
  let currentBrandParam = getCurrentBrandParam();
  
  // Override the history.pushState and history.replaceState methods to detect URL changes
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  
  history.pushState = function(...args) {
    originalPushState.apply(history, args);
    const newBrandParam = getCurrentBrandParam();
    if (newBrandParam !== currentBrandParam) {
      currentBrandParam = newBrandParam;
      handleBrandChange(newBrandParam);
    }
  };
  
  history.replaceState = function(...args) {
    originalReplaceState.apply(history, args);
    const newBrandParam = getCurrentBrandParam();
    if (newBrandParam !== currentBrandParam) {
      currentBrandParam = newBrandParam;
      handleBrandChange(newBrandParam);
    }
  };
}


const brandParam = getCurrentBrandParam();
// Initialize brand parameter monitoring
setupBrandParameterMonitoring();